export default __webpack_public_path__ + "static/media/pricing-blob-bg.7fd8e7a1.svg";